<se-search-settings
    [isCurrentUserAuthorized]="isCurrentUserAuthorized"
    [onSaveSettings]="saveSettings"
    [showSaveSettingsUser]="true"
    [onResetDefaultSettings]="resetDefaultSettings"
    [extraButtons]="[{ label: 'Configura visibilità dei filtri', triggerFor: menuVisibility }]"
    sizeConfiguration="small"
>
</se-search-settings>
<mat-menu #menuVisibility="matMenu" yPosition="above" xPosition="before" (click)="stopPropagation($event)">
    <div (click)="stopPropagation($event)" class="remove-padding">
        <se-ap-search-filters-config-visibility
            [filters]="filters"
            (filtersChanged)="onChangeFilters($event)"
        ></se-ap-search-filters-config-visibility>
    </div>
</mat-menu>
